import { useSuspenseQuery } from '@apollo/client';
import { QUERY_FETCH_RESOURCE_HUB_PAGE, type FetchResourceHubPageQuery } from '@edwin-group/people-graphql';

export const useResourceHubPage = () => {
  const { data } = useSuspenseQuery<FetchResourceHubPageQuery>(QUERY_FETCH_RESOURCE_HUB_PAGE);
  const pageContent = data?.resourceHubPage ?? null;
  return { pageContent };
};
